var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',_vm._g(_vm._b({staticClass:"h-100 text-capitalize",class:_vm.btnClass,attrs:{"depressed":"","color":"warning"}},'v-btn',_vm.$attrs,false),_vm.$listeners),[(_vm.icon)?_c('v-icon',{class:_vm.iconClass,attrs:{"size":_vm.iconSize,"color":_vm.iconColor}},[_vm._v(" "+_vm._s(_vm.icon)+" ")]):_vm._e(),_vm._v(" "+_vm._s(_vm.name)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }